"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));

var useStyles = makeStyles_1.default(function (theme) {
  return {
    cancel: {
      marginLeft: theme.spacing(3)
    }
  };
});

var CancelButton = function CancelButton(props) {
  var classes = useStyles();
  var onClick = props.onClick,
      _props$label = props.label,
      label = _props$label === void 0 ? 'Cancel' : _props$label;
  return react_1.default.createElement(Button_1.default, {
    variant: "contained",
    size: "large",
    className: classes.cancel,
    onClick: onClick
  }, label);
};

exports.default = CancelButton;